import React from "react";
import styled, {
  css,
  type FlattenSimpleInterpolation,
} from "styled-components";
import { type ITextProps, TextAlignment } from "../TextProps";

export const Subtitle1Styles = (
  props: ITextProps,
): FlattenSimpleInterpolation => {
  const textAlign = props.alignment ?? TextAlignment.LEFT;
  const color = props.textColor ?? "var(--colour-black)";

  return css`
    font-family: var(--font-helvetica);
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.0225rem;
    text-align: ${textAlign};
    color: ${color};
    text-transform: initial;
  `;
};

const StyledSubtitle1 = styled.p<ITextProps>`
  ${Subtitle1Styles}
`;

export const Subtitle1: React.FC<ITextProps> = ({
  tag = "p",
  children,
  ...props
}) => (
  <StyledSubtitle1 as={tag} {...props} data-component={"subtitle1"}>
    {children}
  </StyledSubtitle1>
);

export default Subtitle1;
